.discord-message .discord-message-body .discord-quote-container {
	display: flex;
}

.discord-message .discord-message-body .discord-quote-container > .discord-quote-divider {
	background-color: #4f545c;
	border-radius: 4px;
	font-size: 0.9em;
	font-style: normal;
	font-weight: 400;
	margin: 0;
	padding: 0;
	width: 4px;
}

.discord-message .discord-message-body blockquote {
	margin-block-end: unset;
	margin-block-start: unset;
	margin-inline-end: unset;
	margin-inline-start: unset;
	padding: 0 8px 0 12px;
}
